import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, of, switchMap } from 'rxjs';
import { Login } from 'src/app/models/Login';
import { AuthService } from 'src/app/services/auth.service';
import { FooldalService } from 'src/app/services/fooldal.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'],
  animations: [
    trigger('fadeInOut', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [style({ opacity: 0 }), animate(300)]),
      transition(':leave', animate(300, style({ opacity: 0 })))
    ])
  ]
})
export class SigninComponent implements OnInit {

  loginForm: FormGroup;
  loginError?: string;
  showLoginAlert: boolean = false;
  allUserUsername: any[] = [];
  pilot = environment.pilotMode;

  @ViewChild('password', { read: ElementRef, static:false }) password!: ElementRef;
  @ViewChild('togglePasswordIcon', { read: ElementRef, static:false }) togglePasswordIcon!: ElementRef;

  public togglePassword() {
    this.togglePasswordIcon.nativeElement.classList.toggle('bi-eye-slash');
    this.togglePasswordIcon.nativeElement.classList.toggle('bi-eye');
    this.password.nativeElement.type = this.password.nativeElement.type === 'password' ? 'text' : 'password';
  }

  constructor(private authService: AuthService, private route: Router, private userService: UserService, private activedRoute: ActivatedRoute, private fooldalService: FooldalService) {
    const username = localStorage.getItem('last-email')?.replaceAll('"', '') || '';
    this.loginForm = new FormGroup(
      {
        username: new FormControl(username, [Validators.required]),
        password: new FormControl('', [Validators.required])
      }
    )
  }

  ngOnInit(): void {
    this.activedRoute.queryParams.subscribe(params => {
      this.from = params['from'];
    });
  }

  from = undefined;

  getQueryParams() {
    if (this.from === 'elofizetes' || this.from === 'foglalkozasok-teremben') {
      return { from: this.from };
    }
    return null;
  }

  onSubmit() {
    if (this.loginForm.valid) {
      const user: Login = {
        name: this.loginForm.get('username')?.value,
        pass: this.loginForm.get('password')?.value
      }
      this.authService.fetchCsrfToken().pipe(
        switchMap((csrfToken: string) =>
          this.authService.logout('', csrfToken).pipe(
            catchError(() => of(null))
          )
        ),
        switchMap(() => this.authService.login(user)),
        switchMap((loggedIn) => {
          localStorage.setItem('last-email', user.name);
          localStorage.setItem('api-key', JSON.stringify(loggedIn['api-key']));
          return this.authService.syncLocalAuthState(loggedIn);
        })
      ).subscribe(() => {
          if (this.from === 'elofizetes') {
              this.route.navigateByUrl('/elofizetes');
            } else if (this.from === 'foglalkozasok-teremben') {
              this.route.navigateByUrl('/foglalkozasok-teremben');
            } else if (this.authService.isAdmin()) {
              this.route.navigateByUrl('/admin/videotar');
            } else {
              this.route.navigateByUrl('/elofizetes');
            }
      }, error => {
        this.showLoginAlert = true;
        this.loginError = 'Hibás felhasználónév vagy jelszó!';
        setTimeout(() => {
          this.showLoginAlert = false;
        }, 3000);
      });
    }
  }



}
